import { useQuery } from '@provision/graphql-client';
import { isNullish } from 'remeda';
import { GET_CONVERSATION_SUMMARY_QUERY } from 'src/graphql/conversation-summary/conversation-summary.operations';
import { GetConversationSummary } from 'src/graphql/conversation-summary/conversation-summary.types';

export const useConversationSummary = (
  conversationId?: string,
  partnerId?: number,
  skip = false,
) => {
  const { data, ...rest } = useQuery<GetConversationSummary>(GET_CONVERSATION_SUMMARY_QUERY, {
    skip: !conversationId || isNullish(partnerId) || skip,
    fetchPolicy: 'no-cache',
    context: {
      ttl: 0,
    },
    variables: {
      params: {
        conversationId,
        partnerId,
      },
    },
  });

  return {
    conversationSummary: data?.generateConversationSummary,
    ...rest,
  };
};
